<!-- 首页 -->
<template>
  <div class="w100">
    <van-nav-bar class="gradient" :fixed="true" >
      <van-icon
        slot="right"
        :name="require('@/assets/images/public/icon_bell@2x.png')"
        :dot="unreadMsg ? true : false"
        class="icon"
        @click="_linkFun('/notice', 'notice', { type: 0 })"
      />
    </van-nav-bar>
    <div class="head-menu" >
      <div class="item" @click="_linkFun('/paymentCode')">
        <img src="@/assets/images/home/icon_fukuan@2x.png" />
        <p>{{ $t("home.payment") }}</p>
      </div>
      <div class="item" @click="_linkFun('/collectionCode')">
        <img src="@/assets/images/home/icon_shoukuan@2x.png" />
        <p>{{ $t("home.receive") }}</p>
      </div>
      <div class="item" @click="_linkFun('/transfer')">
        <img src="@/assets/images/home/icon_zhuanzhang@2x.png" />
        <p>{{ $t("wallet.transfer") }}</p>
      </div>
    </div>
    <div class="content-wrapper">
      <scroll>
        <!-- <van-swipe
          class="my-swipe"
          v-if="sliderList.length"
          :autoplay="3000"
          indicator-color="white"
        >
          <van-swipe-item v-for="(item, index) in sliderList" :key="index">
            <a v-if="item.url" :href="item.url" target="_blank">
              <img :src="httpUrl + item.image" />
            </a>
            <img v-else :src="httpUrl + item.image" />
          </van-swipe-item>
        </van-swipe> -->
        <!-- banner -->
        <div class="banner-wrapper">
          <div class="slide-wrapper">
            <slider v-if="sliderList.length">
              <div v-for="(item, index) in sliderList" :key="index">
                <a v-if="item.url" :href="item.url" target="_blank">
                  <img class="needsclick" :src="httpUrl + item.image" />
                </a>
                <img v-else class="needsclick" :src="httpUrl + item.image" />
              </div>
            </slider>
          </div>
        </div>
        <!-- 公告 -->
        <div class="notice-bar">
          <div
            class="notice-wrap"
            @click="_linkFun('/notice', 'notice', { type: 1 })"
          >
            <i class="icon_notice"></i>
            <notice-bar v-if="noticeList.length" :data="noticeList" />
          </div>
          <div class="service" @click="_linkFun('/service')">
            {{ $t("home.customerService") }}
          </div>
        </div>

        <div class="entrance">
          <div
            class="item"
            v-for="(item, index) in homeList"
            :key="index"
            @click="clickEntrance(item.key)"
          >
            <div class="image">
              <img :src="httpUrl + item.icon" />
            </div>
            <p>{{ item.name }}</p>
          </div>
          <div class="item"  @click="_linkFun('/allApps')">
            <div class="image">
              <img src="@/assets/images/home/icon/icon_gengduo@2x.png" />
            </div>
            <p>{{ $t("common.more") }}</p>
          </div>
        </div>
      </scroll>
    </div>

   <!-- <div class="download-wrap" v-if="downloadFlag">
      <i class="close" @click="downloadFlag = false">
        <van-icon name="cross" />
      </i>
      <div class="logo">
        <img src="@/assets/images/public/logo_icon@2x.png" />
      </div>
      <h1>{{ $t("home.eepay") }}</h1>
      <a :href="`${httpUrl}/appDown/index.html`" class="btn">
        {{ $t("home.download") }}
      </a>
    </div>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Slider from "@/components/BScroll/slider/slider";
import NoticeBar from "@/components/common/noticeBar";
export default {
  name: "home",
  meta: {
    tabNav: true, // 显示菜单
    power: false, // 权限
    service: false // 客服
  },
  components: {
    Slider,
    NoticeBar
  },
  data() {
    return {
      sliderList: [], // 轮播图
      noticeList: [], // 公告
      downloadFlag: true,
      homeData: {},
      moreIcon: [],
      homeList: [],
      unreadMsg: 0
    };
  },
  created() {
    this._getHomeData();
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    clickEntrance(key) {
      // 入口
      let vm = this;
      if (key == 21) {
        vm._linkFun("/combo");
      } else if (key == 22) {
        vm._linkFun("/batch");
      } else if (key == 23) {
        vm._linkFun("/single");
      } else {
        vm._linkFun("/onlinePay?flag=" + key);
      }
    },
    _getHomeData() {
      // 获取首页数据
      let vm = this;
      let enter = vm.enter;
      vm.$post("/app/index/index", {enter}, { loading: true }).then(res => {
        console.log("home", res);
        vm.homeData = res;
        vm.moreIcon = res.icon.icon;
        vm.homeList = res.icon.icon_index;
        vm.sliderList = res.images;
        vm.noticeList = res.system_notice;
        console.log("homeList", vm.homeList);
      });
    },
    _getNoticeNum() {
      let vm = this;
      vm.$post("/app/index/notice", { type: 4 }, { loading: true }).then(
        res => {
          console.log("notice", res);
          vm.unreadMsg = res;
        }
      );
    }
  },
  watch: {
    userInfo: {
      handler(obj) {
        if (obj.username) {
          this._getNoticeNum();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
.head-menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 10px;
  padding-top: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: linear-gradient(90deg, #2043ac, #130f73);
  .item {
    width: 33.33%;
    padding: 0 8px;
    text-align: center;
    img {
      width: 32px;
      height: 32px;
    }
    p {
      padding-top: 4px;
      font-size: 14px;
      line-height: 16px;
    }
  }
}

.content-wrapper {
  top: 106px;
}

/deep/.my-swipe {
  .van-swipe-item {
    // max-height: 180px;
    img {
      width: 100%;
    }
  }
  .van-swipe__indicators {
    .van-swipe__indicator {
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.4);
      &.van-swipe__indicator--active {
        width: 16px;
        background: rgba(255, 255, 255, 1);
      }
    }
  }
}

// banner
.banner-wrapper {
  width: 100%;
  padding: 10px 0;
  background: #fff;
  overflow: hidden;
  .slide-wrapper {
    position: relative;
    width: 88%;
    margin: 0 auto;
    /deep/.slide-item {
      overflow: hidden;
      padding: 0 5px;
      .needsclick {
        // height: 200px;
        border-radius: 8px;
      }
    }
    /deep/.dots {
      .dot {
        background: rgba(255, 255, 255, 0.4);
        &.active {
          background: rgba(255, 255, 255, 1);
        }
      }
    }
  }
}

// notice
.notice-bar {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  height: 24px;
  background: #fff;
  overflow: hidden;
  .notice-wrap {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    height: 24px;
    overflow: hidden;
    i {
      margin: 3px 5px 0 0;
      &.icon_notice {
        flex: 0 0 18px;
        width: 18px;
        height: 18px;
        background-image: url("~@/assets/images/home/icon_notice@2x.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
      }
    }
    /deep/.notice {
      flex: 1;
      overflow: hidden;
      li {
        line-height: 24px;
      }
    }
  }
  .service {
    margin-left: 10px;
    font-size: 12px;
    color: #2042ab;
    text-decoration: underline;
  }
}

.entrance {
  margin: 10px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .item {
    padding: 5px;
    width: 25%;
    display: flex;
    flex-direction: column;
    text-align: center;
    transition: all 0.5s;
    &.dragging {
      transform: scale(1.1);
      opacity: 0.9;
    }
    .image {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 44px;
      overflow: hidden;
      img {
        max-width: 100%;
        max-height: 44px;
      }
    }
    p {
      width: 100%;
      padding-top: 5px;
      line-height: 1;
      font-size: 14px;
    }
  }
}

.download-wrap {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 50px;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 10px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  .close {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    /deep/.van-icon {
      font-size: 18px;
      color: #fff;
    }
  }
  .logo {
    margin-right: 10px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    img {
      width: 100%;
    }
  }
  h1 {
    flex: 1;
    font-size: 16px;
    font-weight: 400;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .btn {
    padding: 0 10px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    color: #fff;
    border: 1.1px solid #fff;
    border-radius: 3px;
  }
}
</style>
